import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Relation = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 4.96628C2 4.06244 2.73271 3.32973 3.63655 3.32973H9.01326C9.91711 3.32973 10.6498 4.06244 10.6498 4.96628V7.82177C10.6498 8.72562 9.91711 9.45833 9.01326 9.45833H8.22449C7.87686 9.45833 7.59505 9.17651 7.59505 8.82888C7.59505 8.48125 7.87686 8.19944 8.22449 8.19944H9.01326C9.22184 8.19944 9.39093 8.03035 9.39093 7.82177V4.96628C9.39093 4.7577 9.22184 4.58861 9.01326 4.58861H3.63655C3.42797 4.58861 3.25889 4.7577 3.25889 4.96628V7.82177C3.25889 8.03035 3.42798 8.19944 3.63655 8.19944H4.66724C5.01487 8.19944 5.29669 8.48125 5.29669 8.82888C5.29669 9.17651 5.01487 9.45833 4.66724 9.45833H3.63655C2.73271 9.45833 2 8.72561 2 7.82177V4.96628Z"
        fill="currentColor"
      />
      <path
        d="M5.48835 8.10915C5.48835 7.2053 6.22106 6.47259 7.1249 6.47259H7.91372C8.26135 6.47259 8.54316 6.7544 8.54316 7.10204C8.54316 7.44967 8.26135 7.73148 7.91372 7.73148H7.1249C6.91633 7.73148 6.74724 7.90057 6.74724 8.10915V11.0337C6.74724 11.2423 6.91633 11.4114 7.1249 11.4114H12.3634C12.572 11.4114 12.7411 11.2423 12.7411 11.0337V8.10915C12.7411 7.90057 12.572 7.73148 12.3634 7.73148H11.7819C11.4342 7.73148 11.1524 7.44967 11.1524 7.10204C11.1524 6.7544 11.4342 6.47259 11.7819 6.47259H12.3634C13.2673 6.47259 14 7.2053 14 8.10915V11.0337C14 11.9376 13.2673 12.6703 12.3634 12.6703H7.1249C6.22106 12.6703 5.48835 11.9376 5.48835 11.0337V8.10915Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Relation;
